export class ClosureRequestModel {
    engageEngagementId: number;
    closeOutInitiatedBy: string;
    closingOutTimespan: number;
    engageEngagementStatus: string;
}
